import { lazy } from 'react';
import { Route } from 'react-router-dom';

const SignInView = lazy(() => import('./view/SignInView'));

export default [<Route path="/" element={<SignInView />} />];
